<h3 class="card-header">
  <div class="row center">
    <p id="header-text" class="d-inline-block text-left">
      {{ "DIARY_SLEEP_STATS" | translate }}
    </p>
    <!--<p id="header-subtext" class="d-inline-block text-right">USERNAME</p>-->
  </div>
</h3>
